import { Monitor, Smartphone } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useMessengerAppStatus } from "@/hooks/useDesktopAppStatus";
import { cn } from "@/lib/utils";

/**
 * 채팅 목록 상단 "새채팅" 옆의 메신저 앱 설치 버튼 → /desktop-app (Windows 메신저 + Android 앱 다운로드).
 * 접속 OS 에 맞는 앱이 이미 있으면 숨긴다: Windows 는 데스크톱 앱(이 PC 실행 중/최근 설치),
 * Android 는 모바일 앱(최근 14일 앱 활동). iOS 는 제공 앱이 없어 숨기고, Mac 등은 QR 설치용으로 보인다.
 */
export default function DesktopAppButton({
  className,
  iconClassName = "h-3 w-3 mr-1",
  onNavigate,
}: {
  className?: string;
  iconClassName?: string;
  /** 이동 직전 호출 (사이드바 닫기 등) */
  onNavigate?: () => void;
}) {
  const navigate = useNavigate();
  const { platform, showInstallButton } = useMessengerAppStatus();
  if (!showInstallButton) return null;
  const Icon = platform === "windows" ? Monitor : Smartphone;
  return (
    <Button
      size="sm"
      variant="outline"
      className={cn("text-primary border-primary/40 hover:bg-primary/5", className)}
      title="메신저 앱 설치"
      onClick={() => {
        onNavigate?.();
        navigate("/desktop-app");
      }}
    >
      <Icon className={iconClassName} />
      메신저 설치
    </Button>
  );
}
